import React from 'react';
import backImg from '../assets/images/back.svg'

const Pagination = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  if (!totalItems) return null; // if nothing to paginate at all

  const visiblePagesCount = 3;

  const getVisiblePages = () => {
    const pages = [];

    const maxStart = Math.max(1, totalPages - visiblePagesCount + 1);
    const start = Math.min(Math.max(currentPage - 1, 1), maxStart);

    for (let i = start; i < start + visiblePagesCount && i <= totalPages; i++) {
      pages.push(i);
    }

    return pages;
  };

  const pages = getVisiblePages();
  const showEllipsis = pages[pages.length - 1] < totalPages - 1;
  const showLastPage = pages[pages.length - 1] < totalPages;

  return (
    <div className="pagination">
      <button
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        <img
          src={backImg}
          alt=""
        />
      </button>

      {pages.map((page) => (
        <button
          key={page}
          className={page === currentPage ? 'active' : ''}
          onClick={() => onPageChange(page)}
        >
          {page}
        </button>
      ))}

      {showEllipsis && <span className="ellipsis">...</span>}

      {showLastPage && (
        <button
          className={currentPage === totalPages ? 'active' : ''}
          onClick={() => onPageChange(totalPages)}
        >
          {totalPages}
        </button>
      )}

      <button
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        <img
          src={backImg}
          alt=""
          style={{ transform: 'rotate(176deg)' }}
        />
      </button>
    </div>
  );
};

export default Pagination;
